import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { GlobalStyle } from './App.style';

import './App.css';
import Loading from './Components/Loading/Loading';
import Routes from './Core/Routes/Routes';
import Interceptors from './Service/Interceptors/Interceptors';
import { Helmet } from 'react-helmet-async';
import 'animate.css';
function App() {
  return (
    <Suspense fallback={<Loading />}>
      <Helmet>
        <meta name="apple-mobile-web-app-title" content="Your App Name" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
         <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"
  />
      </Helmet>
      <Router>
        <Routes />
        <GlobalStyle />
        <Interceptors />
        <ToastContainer limit={3} />
      </Router>
    </Suspense>
  );
}

export default App;
